import { PureComponent } from 'react';
import cx from 'classnames';
import { Tooltip } from 'react-tippy';
import { connect } from 'react-redux';
import tinycolor from 'tinycolor2';
import { selectPalette } from 'root/selectors';
import './RadioGroup.scss';

export class RadioGroup extends PureComponent {
  state = {
    hovering: null,
  };

  getOFFColor = (colorFromPalette) => tinycolor(colorFromPalette).darken(60).toString();

  getONColor = (colorFromPalette) => tinycolor(colorFromPalette).toString();

  resolveClassNames = (option, index) => {
    const { showAsBoxes, options, value } = this.props;
    return showAsBoxes
      ? cx(
          {
            mr2: index === 0,
            'mr2 ml2': index > 0 && index < options.length - 1,
            ml2: index === options.length - 1,
            selected: value === option.value,
          },
          'br1'
        )
      : cx('flex-shrink-0', {
          'pb-2': index === 0,
          'pb-2 pt-2': index > 0 && index < options.length - 1,
          'pt-2': index === options.length - 1,
          selected: value === option.value,
        });
  };

  resolveClassNamesInner = (option) => {
    const { showAsBoxes, value } = this.props;
    return showAsBoxes
      ? cx('pt3 pb3 pr4 pl4 flex items-center justify-center br1 bw0', {
          'bg-link bc-link selected': value === option.value,
        })
      : 'items-center';
  };

  handleClick = (option) => {
    const { enableDeselect, onChange, value } = this.props;
    if (enableDeselect && value === option.value) {
      onChange(null);
    } else if (value !== option.value) {
      onChange(option.value);
    }
  };

  render = () => {
    const { options, showAsBoxes, disabled, className, value, palette } = this.props;
    const { hovering } = this.state;
    const onColor = this.getONColor(palette.link);
    return (
      <ul
        className={cx('uw-radio-group ma0 pa0', className, {
          'flex items-center as-boxes': showAsBoxes,
          'inline-flex flex-column': !showAsBoxes,
          disabled,
        })}
      >
        {options.map((option, index) => (
          <li
            key={option.value}
            onClick={() => this.handleClick(option)}
            className={cx(`border-box lh-copy relative pointer ${this.resolveClassNames(option, index)}`, {
              disable: option.disable,
            })}
            style={
              showAsBoxes && {
                background: value !== option.value && tinycolor(palette.sourceBg).toString(),
                width: `calc(${100 / options.length}% - ${(8 * (options.length - 1)) / options.length}px)`,
              }
            }
            onMouseEnter={() => {
              this.setState({ hovering: index });
            }}
            onMouseLeave={() => {
              this.setState({ hovering: null });
            }}
          >
            <Tooltip
              title={option.tip}
              disabled={!option.tip}
              className={`inner w-100 flex-grow-1 border-box ${this.resolveClassNamesInner(option)}`}
              arrow
              animation="scale"
              delay={200}
              duration={200}
              hideDelay={0}
              size="small"
            >
              {!showAsBoxes && (
                <div
                  className="circle flex items-center flex-shrink-0 justify-center mr-3"
                  style={{ borderColor: value === option.value ? onColor : this.getOFFColor(palette.sourceBg) }}
                >
                  <div className={cx('dot flex-shrink-0')} style={{ background: onColor }} />
                </div>
              )}
              {showAsBoxes && (
                <div
                  className={cx('hover bc-link br1 bw2 border-box', {
                    show: hovering === index,
                  })}
                />
              )}
              <div
                className={cx('flex-grow-1 tc label', {
                  fw7: value === option.value,
                  'c-window': value === option.value && showAsBoxes,
                })}
              >
                {option.label}
              </div>
            </Tooltip>
          </li>
        ))}
      </ul>
    );
  };
}

const mapStateToProps = (state) => ({
  palette: selectPalette(state),
});

export default connect(mapStateToProps, null)(RadioGroup);
